import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import {formatPrice,formatQuantity} from '../helpers/helpers'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';
import ReviewQuote from './ReviewQuote';
import LaborView from './LaborView';
import PrintLabor from './PrintLabor'

class ReviewTab extends Component {

    constructor(){
        super();

        this.approved = this.approved.bind(this)
        this.disapproved = this.disapproved.bind(this)
        this.state={
            userId :"",
            user : {},
            quotation : {},
            customer:{},
            labor : {},
            corners:{}
            
        }
        
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId:data.key,
                        user:data.val()
                      });

                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 

        let quotation = ref.child("Quotation").child(this.props.match.params.qid);
            quotation.on("value", function(snap){
                this.setState({
                    quotation : snap.val(),
                    customer : snap.val().customer,
                    products : snap.val().products,
                    labor : snap.val().labor,
                    corners :snap.val().corners
                })
            }.bind(this)) 

        
    }

    approved(){
        let statusUpdate ={
                checkBy : this.state.user.firstname,
                checkByUserId : this.state.userId,
                status : "Deal"
            }
        ref.child("Quotation").child(this.props.match.params.qid).update(statusUpdate).then(()=>{
            alert("Quotation has been Closed Deal ")
        })
        window.location.assign("/quotation/approved")
    }

    disapproved(){
        window.location.assign("/quotation/"+this.props.match.params.qid+"/update")
    }
    
    render() {
            
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar/>
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Review Quotation" />
                            <div className="block">
                                <div>                             
                                {/*<!-- Working Tabs Block -->*/}
                                <div className="block full">
                                    {/*<!-- Working Tabs Content -->*/}
                                    <div className="row">
                                        <div className="col-md-12">
                                            {/*<!-- Block Tabs -->*/}
                                            <div >
                                                {/*<!-- Block Tabs Title -->*/}
                                                <div className="block-title no-print">
                                                    <div className="block-options pull-right">
                                                        <div className="btn-group">
                                                            <a className="btn btn-alt btn-sm btn-default dropdown-toggle" data-toggle="dropdown" href="javascript:void(0)"><i className="fa fa-angle-down"></i></a>
                                                            <ul className="dropdown-menu dropdown-custom dropdown-menu-right">
                                                                <li>
                                                                    <a href="javascript:void(0)">Action</a>
                                                                    <a href="javascript:void(0)">Action 2</a>
                                                                </li>
                                                                <li className="divider"></li>
                                                                <li><a href="javascript:void(0)">Another Action</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <ul className="nav nav-tabs" data-toggle="tabs">
                                                        <li className="active"><a href="#example-tabs2-activity">Quotation</a></li>
                                                        <li><a href="#example-tabs2-profile">Labor</a></li>
                                                        
                                                    </ul>
                                                </div>
                                                {/*<!-- END Block Tabs Title -->*/}

                                                {/*<!-- Tabs Content -->*/}
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="example-tabs2-activity">
                                                        {/**********<!-- Quotation -->**********/}
                                                        <ReviewQuote quotation ={this.state.quotation} customer ={this.state.customer} products={this.state.products}
                                                            approved={this.approved} disapproved={this.disapproved}/>
                                                        
                                                    </div>
                                                    <div className="tab-pane" id="example-tabs2-profile">
                                                        {/**********<!-- Labor -->**********/}
                                                        <div className="no-print">
                                                            <table className="table table-bordered">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="text-left forRoofType">Product Name</th>
                                                                        <th className="text-center forLengthSize">Quantity</th>
                                                                        <th className="text-center forLengthSize">Price</th>
                                                                        <th className="text-center forLengthSize">Discount</th>
                                                                        <th className="text-center forUnitType">Total</th>
                                                                        
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="forInputArea">
                                                                    {

                                                                        this.state.labor &&                                     
                                                                            Object.keys(this.state.labor).map(function (key){
                                                                                let list = this.state.labor[key]                                                                                                                             
                                                                                    
                                                                                    return <LaborView ref={key} key={key} index={key} product ={list}/>                                                    
                                                                                  
                                                                            }.bind(this))

                                                                    }
                                                                    <tr>
                                                                    <td>Corners</td>                                        
                                                                    <td>{formatQuantity(this.state.corners.cornerQty?this.state.corners.cornerQty:0)}</td>
                                                                    <td>{this.state.corners.cornerPrice?this.state.corners.cornerPrice:0}</td>
                                                                    <td>{this.state.corners.cornerDis?this.state.corners.cornerDis:0}%</td>
                                                                    <td>{formatPrice(this.state.corners.cornerTotal?this.state.corners.cornerTotal:0)}</td>
                                                                    </tr>
                                                                    <tr>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td className="grandTotalQ">Total</td>
                                                                    <td className="grandTotal">{formatPrice(this.state.quotation.laborCost)}</td>
                                                                    </tr>                                    
                                                                </tbody>
                                                            </table>
                                                            <div className="printThis">                                                  
                                                                <button type="button" className="btn btn-primary pull-right" onClick={()=>window.print()}><i className="fa fa-print"></i></button>
                                                            </div>
                                                        </div>
                                                        <PrintLabor data={this.state.labor} quotation={this.state.quotation} corners={this.state.corners} customer={this.state.customer}/>
                                                    </div>
                                                </div>
                                                {/*<!-- END Tabs Content -->*/}
                                            </div>
                                            {/*<!-- END Block Tabs -->*/}
                                        </div>
                                    </div>
                                    {/*<!-- END Working Tabs Content -->*/}
                                </div>
                                {/*<!-- Working Tabs Block -->*/}
                             </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        );
    }
}

export default ReviewTab;



// WEBPACK FOOTER //
// ./src/components/ReviewTab.js